var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.iconSrc)?_c('div',{staticClass:"service-box",on:{"click":_vm.handLink}},[_c('nx-image',{staticClass:"service-icon",attrs:{"src":_vm.iconSrc}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }